"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @deprecated This should be project by project basis and not a common feature
 */
var EditorMode;
(function (EditorMode) {
    EditorMode["APPROVE"] = "APPROVE";
    EditorMode["CREATE"] = "CREATE";
    EditorMode["DELETE"] = "DELETE";
    EditorMode["EDIT"] = "EDIT";
})(EditorMode || (EditorMode = {}));
exports.default = EditorMode;
//# sourceMappingURL=EditorMode.js.map